import { createStore, select, withProps } from '@ngneat/elf';
import { InitializationState } from '@tmx/core';

interface AmsFeaturesProps {
  amsFeaturesState: InitializationState;
  canEditWeather: boolean;
  showAssets: boolean;
  showCfs: boolean;
  showDashboard: boolean;
  showDiagnostics: boolean;
  showFleetAccounts: boolean;
  showManageAccount: boolean;
  showReporting: boolean;
  showWeather: boolean;
}

const amsFeaturesStore = createStore(
  { name: 'ams-features' },
  withProps<AmsFeaturesProps>({
    amsFeaturesState: 'loading',
    canEditWeather: false,
    showAssets: false,
    showCfs: false,
    showDashboard: false,
    showDiagnostics: false,
    showFleetAccounts: false,
    showManageAccount: false,
    showReporting: false,
    showWeather: false,
  })
);

/** Snapshots */

export const amsFeaturesStoreSnapshot = () => amsFeaturesStore.getValue();

/** Exposed Variables and Observables */

export const amsFeaturesState$ = amsFeaturesStore.pipe(
  select(({ amsFeaturesState }) => amsFeaturesState)
);

export const showCfs$ = amsFeaturesStore.pipe(select(({ showCfs }) => showCfs));

export const showDiagnostics$ = amsFeaturesStore.pipe(
  select(({ showDiagnostics }) => showDiagnostics)
);

export const showFleetAccounts$ = amsFeaturesStore.pipe(
  select(({ showFleetAccounts }) => showFleetAccounts)
);

export const showWeather$ = amsFeaturesStore.pipe(
  select(({ showWeather }) => showWeather)
);

/** Updater Functions */

export function updateAmsFeatures(
  amsFeatures: Omit<AmsFeaturesProps, 'amsFeaturesState'>
) {
  amsFeaturesStore.update(() => ({
    ...amsFeatures,
    amsFeaturesState: 'initialized',
  }));
}

export function updateAmsFeaturesState(amsFeaturesState: InitializationState) {
  amsFeaturesStore.update((state) => ({
    ...state,
    amsFeaturesState,
  }));
}

export function resetAmsFeaturesStore() {
  amsFeaturesStore.reset();
}
